// @/services/content/store/modules/first-run.js
/**
 * First Run content handler
 * Handles retrieval of localized content for the First Run experience
 */
export class FirstRunHandler {
  /**
   * Create a new First Run content handler
   * @param {Object} store - Content store reference
   */
  constructor(store) {
    this.store = store;
  }

  /**
   * Get First Run content by locale
   * @param {string} locale - Locale to get content for (defaults to 'en')
   * @returns {Object|null} - Content object or null if not available
   */
  getContent(locale = 'en') {
    // First try the requested locale
    const localeContent = this.store.state.data.firstRun?.[locale];
    
    // Fall back to English if the requested locale isn't available
    if (!localeContent && locale !== 'en') {
      return this.store.state.data.firstRun?.['en'] || null;
    }
    
    return localeContent || null;
  }
}